import React from 'react'

import _ from 'lodash'

import { FEEDBACK } from '../../constants'
import { isNullOrUndefined, truncateString } from '../../utils'

import Feedback from './Feedback'

const IGNORE_FORMATS = ['PLAIN_TEXT']
const MAX_URI_LENGTH = 30

/**
 * ResultFooter component for displaying the footer of a KENSearch result.
 *
 * @see https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/resultsPanel/components/ResultFooter.tsx
 * @example
 * const attributes = { ... }
 * const queryResultItem = { ... }
 * const submitFeedback = (feedbackType, queryResultItem) => { ... }
 * return <ResultFooter attributes={attributes} queryResultItem={queryResultItem} submitFeedback={submitFeedback} />
 */
export default class ResultFooter extends React.Component {
  submitClickFeedback = () => {
    this.props.submitFeedback(FEEDBACK.CLICK, this.props.queryResultItem)
  }

  addPage = (uri, attributes) => {
    if (attributes._excerpt_page_number === undefined) {
      return uri
    }
    return uri + '#page=' + attributes._excerpt_page_number.LongValue
  }

  render() {
    const { attributes, queryResultItem, submitFeedback } = this.props

    const fileFormatName = attributes.FileFormat
      ? attributes.FileFormat.StringValue
      : undefined

    let fileFormat
    if (
      !isNullOrUndefined(fileFormatName) &&
      IGNORE_FORMATS.indexOf(fileFormatName) === -1
    ) {
      fileFormat = (
        <div className="display-inline">
          {fileFormatName.toUpperCase()}
          <div className="file-format-divider-wrapper">
            <div className="file-format-divider" />
          </div>
        </div>
      )
    }

    let sourceLink

    const uri = this.addPage(queryResultItem.DocumentURI, attributes)
    if (uri && !_.isEmpty(uri)) {
      sourceLink = (
        <div>
          <a
            href={uri.replace('%2F%2F', '')}
            onClick={this.submitClickFeedback}
            target="_blank"
            rel="noopener noreferrer"
          >
            {truncateString(uri, MAX_URI_LENGTH)}
          </a>
        </div>
      )
    }

    return (
      <div
        style={{
          display: 'flex',
          paddingBottom: '10px',
          borderBottom: '1px solid #ccc'
        }}
      >
        <div>
          {fileFormat}
          {sourceLink}
        </div>
        <Feedback
          queryResultItem={queryResultItem}
          submitFeedback={submitFeedback}
        />
      </div>
    )
  }
}
